// extracted by mini-css-extract-plugin
module.exports = {"main-layout__body":"z23jH9abYM4heuV6OKD7a","main-layout__row":"_1EJ2tvqoAPSSxmvLHJ28Eq"};